import { inMemoryStorage } from "@lookiero/sty-psp-storage";
const inMemoryStorageNotifications = () => inMemoryStorage();
export { inMemoryStorageNotifications };
